export default __webpack_public_path__ + "static/media/Fred-Cover.09fc937f.png";